"use client";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="cs">
      <body
        style={{
          margin: 0,
          padding: "4rem 1.5rem",
          fontFamily: "system-ui, sans-serif",
          color: "#4B5563",
          textAlign: "center",
        }}
      >
        <h1 style={{ color: "#1B2A49", fontFamily: "Georgia, serif" }}>
          Něco se pokazilo
        </h1>
        <p style={{ maxWidth: "32rem", margin: "1rem auto" }}>
          Omlouváme se, došlo k neočekávané chybě. Zkuste prosím stránku načíst
          znovu nebo se vraťte na úvodní stránku.
        </p>
        <button
          type="button"
          onClick={reset}
          style={{
            marginTop: "1rem",
            padding: "0.75rem 1.5rem",
            borderRadius: "0.375rem",
            border: "none",
            background: "#1B2A49",
            color: "#ffffff",
            fontSize: "1rem",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Zkusit znovu
        </button>
        {error.digest ? (
          <p style={{ marginTop: "1.5rem", fontSize: "0.75rem" }}>
            Kód chyby: {error.digest}
          </p>
        ) : null}
      </body>
    </html>
  );
}
